import { Tooltip, Typography } from "@mui/material";
import useClientContext from "../../../../../../context/useClientContext";

export default function EntityLevelAccess() {
  const { isAllowedToAccessAllEntities } = useClientContext();

  if (!isAllowedToAccessAllEntities) {
    return (
      <Tooltip title="Data access is restricted through Entity Level Access. Please contact your administrator for further information on this feature.">
        <Typography color="primary" sx={{ textDecoration: "underline dotted", cursor: "help" }}>
          Entity Level Access
        </Typography>
      </Tooltip>
    );
  }
  return null;
}
